import { getCamera } from '../services/cameras';
import { listFactories, getFactoryDetail } from '../services/factories';

/**
 * Полный путь камеры в иерархии для предзаполнения каскада (ТЗ №04/FIX-04).
 *
 * Ответы GET /rooms/{id}, /sections/{id}, /workshops/{id} ссылок на родителя
 * не содержат (RoomDetail/SectionDetail/WorkshopDetail в контракте), поэтому
 * путь вверх по ним не собрать. Камера даёт room_id, а дерево объекта
 * (GET /factories/{id} — workshops → sections → rooms) — его родителей.
 *
 * Цена — 1 + N GET (камера, список объектов и дерево каждого объекта):
 * отдельного эндпоинта «путь камеры» у backend нет. Запросы только читающие,
 * результат нужен один раз при открытии формы, отмена не требуется.
 */

const normalize = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.results)) return data.results;
  if (Array.isArray(data?.items)) return data.items;
  return [];
};

const list = (value) => (Array.isArray(value) ? value : []);

/** { workshopId, sectionId, roomId } строками или null. */
export const findRoomPath = (factoryDetail, roomId) => {
  const target = String(roomId);
  for (const workshop of list(factoryDetail?.workshops)) {
    for (const section of list(workshop?.sections)) {
      for (const room of list(section?.rooms)) {
        if (String(room?.id) === target) {
          return { workshopId: String(workshop.id), sectionId: String(section.id), roomId: target };
        }
      }
    }
  }
  return null;
};

/**
 * { value, cameraName } или null, если путь найти не удалось: value — значение
 * для CameraHierarchyFilter, cameraName — имя камеры из того же GET (может
 * отсутствовать). При null форма остаётся с одной камерой, как раньше.
 */
export const resolveCameraHierarchy = async (cameraId) => {
  try {
    const camera = await getCamera(cameraId);
    const roomId = camera?.room_id;
    if (roomId === null || roomId === undefined) return null;

    const factories = normalize(await listFactories());
    const details = await Promise.all(
      factories.map((factory) => getFactoryDetail(factory.id)
        .then((detail) => ({ factory, detail }))
        .catch(() => null))
    );

    for (const entry of details) {
      const path = entry && findRoomPath(entry.detail, roomId);
      if (path) {
        return {
          value: { factoryId: String(entry.factory.id), ...path, cameraId: String(cameraId) },
          cameraName: camera?.name || '',
        };
      }
    }
    return null;
  } catch {
    return null;
  }
};
